/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import TimeAgo from "layouts/businessUserDashboard/TimeAgo";
import OrdersOverview from "layouts/superAdminDashbord/components/OrdersOverview";
import Projects from "layouts/superAdminDashbord/components/Projects";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSuperAdminDasboardBarChartData, getSuperAdminDasboardLineChartData, getSuperAdminDasboardLineChartDataRevenue, getSuperAdminDashboardData } from "utils/superAdminApi";

function Dashboard() {
  const [paidUserCount, setPaidUserCount] = useState(0);
  // const [paidUserLastMonthPercentage, setPaidUserLastMonthPercentage] = useState(0);
  const [trialUserLastMonthPercentage, setTrialUserLastMonthPercentage] = useState(0);
  const [trialUserCount, setTrialUserCount] = useState(0);
  const [businessUserCustomerCount, setBusinessUserCustomerCount] = useState(0);
  const [businessUserCustomerLastMonthPercentage, setBusinessUserCustomerLastMonthPercentage] = useState(0);
  const [totalRevenueAmount, setTotalRevenueAmount] = useState(0);
  const [totalRevenueAmountPercentage, setTotalRevenueAmountPercentage] = useState(0);
  const currentDate = new Date();
  const [chartDataTotalBusinessUser, setChartDataTotalBusinessUser] = useState([]);
  const [chartDataTotalBusinessUserCustomers, setChartDataTotalBusinessUserCustomers] = useState([]);
  const [chartDataTotalRevenueAmount, setChartDataTotalRevenueAmount] = useState([]);
  const labels = [];
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const dispatch = useDispatch()


  // Creating label of last six months
  // for (let i = 5; i >= 0; i--) {
  //   const date = new Date(currentDate);
  //   date.setMonth(date.getMonth() - i);
  //   const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  //   labels.push(monthNames[date.getMonth()]);
  // }
  function getMonthLabel() {
    for (let i = 5; i >= 0; i--) {
      const date = new Date(currentDate);
      date.setMonth(date.getMonth() - i);
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      labels.push(monthNames[date.getMonth()]);
    }
    return labels;
  }
  useEffect(() => {
    Promise.all([
      fetchSuperAdminDasboardData(),
      fetchSuperAdminDasboardBarChartData(),
      fetchSuperAdminDasboardLineChartData(),
      fetchSuperAdminDasboardLineChartDataRevenue()
    ])

  }, []);

  const handleRefreshButtonClick = () => {
    window.location.reload();
  };


  const fetchSuperAdminDasboardData = async () => {
    getSuperAdminDashboardData((data) => {
      let resData = data.output;
      if (resData.ActivePaidUserCount) {
        setPaidUserCount(resData.ActivePaidUserCount);
      }
      if (resData.ActiveTrialUserCount) {
        setTrialUserCount(resData.ActiveTrialUserCount);
      }
      if (resData.ActiveBusinessUserCustomerCount) {
        setBusinessUserCustomerCount(resData.ActiveBusinessUserCustomerCount);
      }
      if (resData.TotalRevenueAmount) {
        setTotalRevenueAmount(resData.TotalRevenueAmount);
      }
    }, dispatch)
  }

  const fetchSuperAdminDasboardBarChartData = async () => {
    getSuperAdminDasboardBarChartData((data) => {
      let transformedData = data.output
      const counts = [];
      transformedData.forEach((item) => {
        counts.push(item.count);
      });
      setChartDataTotalBusinessUser(counts);
    }, dispatch)

  }

  const fetchSuperAdminDasboardLineChartData = async () => {

    getSuperAdminDasboardLineChartData((data) => {
      let transformedData = data.output
      const counts = [];
      transformedData.forEach((item) => {
        counts.push(item.count);
      });
      setChartDataTotalBusinessUserCustomers(counts);
    }, dispatch)

  }
  const fetchSuperAdminDasboardLineChartDataRevenue = async () => {
    getSuperAdminDasboardLineChartDataRevenue((data) => {
      let transformedData = data.output
      const counts = [];
      transformedData.forEach((item) => {
        counts.push(item.count);
      });
      setChartDataTotalRevenueAmount(counts);
    }, dispatch)

  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        <Grid item xs={1} md={5} lg={9.5}></Grid>
        <Grid item xs={1} md={5} lg={2} display={"flex"} alignItems={"center"} justifyContent={"center"}><b style={{ fontSize: '14px' }}><TimeAgo timestamp={timestamp} /></b></Grid>
        <Grid item xs={1} md={1} lg={0.5} className="largeFont">
          <MDButton
            rel="noreferrer"
            variant="gradient"
            color="success"
            fullWidth
            onClick={handleRefreshButtonClick}
          >
            <RefreshIcon color="light" sx={{ cursor: "pointer" }} />
          </MDButton>
        </Grid>
      </Grid>
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                // icon="weekend"
                icon={<PeopleAltIcon />}
                title="Total Paid Business Users"
                count={paidUserCount}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                // icon="leaderboard"
                icon={<PeopleAltIcon />}
                title="Total Trial Users"
                count={trialUserCount}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                // icon="store"
                icon={<CurrencyRupeeIcon />}
                title="Total Revenue ($)"
                count={totalRevenueAmount}
              // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                // icon="person_add"
                icon={<HowToRegIcon />}
                title="Total Active Customers"
                count={businessUserCustomerCount}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="Total Business Users (Paid & Trial)"
                  chart={{
                    labels: getMonthLabel(),
                    datasets: {
                      label: "Total Business Users",
                      backgroundColor: ["rgba(255, 255, 255, 0.8)"],
                      data: [chartDataTotalBusinessUser],
                    },
                  }}
                />

              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="Total Revenue ($)"
                  chart={{
                    labels: labels, datasets: { label: "Total Revenue", data: chartDataTotalRevenueAmount },
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="Total Active Customers"
                  chart={{
                    labels: labels, datasets: { label: "Total Customers", data: chartDataTotalBusinessUserCustomers },
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
